<ng-container *ngIf="isBusClassCompute">
    <div [ngClass]="{'lm-is-radio-in-paragraph': lmParagraphLayoutInfo, 'lm-radio-field-options': true}">
        <input type="radio"
            class="radio"
            soho-radiobutton (change)="handleComputeTypeChange($event)"
            soho-trackdirty
            id="option1ComputeType" attr.name="optionsComputeType" value="compute"
            attr.data-automation-id="{{computeOptionAutomationId}}"
            [(ngModel)]="computeType"/>
        <label soho-label for="option1ComputeType" [forRadioButton]="true" class="lm-radio-button-label">{{ 'ComputeEditorColumnComputeLabel' | translate}}</label>
        <input type="radio"
            class="radio"
            soho-radiobutton (change)="handleComputeTypeChange($event)"
            soho-trackdirty
            id="option2ComputeType" attr.name="optionsComputeType" value="derived"
            attr.data-automation-id="{{derivedOptionAutomationId}}"
            [(ngModel)]="computeType"/>
        <label soho-label for="option2ComputeType" [forRadioButton]="true" class="lm-radio-button-label">{{ 'DerivedLabel' | translate}}</label>
    </div>
</ng-container>
<label *ngIf="label"
  [attr.for]="id"
  soho-label
    [required]="required$ | async"
  lm-label
    [layoutField] = "field"
>{{triggerValueChange | async | formatLabelRule:field:labelResourceValue:model:specFields}}</label>
<div class="field">
    <div
        lm-field-options
        [hasContextMenu]="insertContextMenu"
        [ajaxCallbackFunction]="onBeforeContextMenuOpen"
        [contextMenuEventFunction]="contextMenuClicked"
        [lmParagraphLayoutInfo]="lmParagraphLayoutInfo"
        [buttonId]="fieldOptionsId"
        [fieldOptionsLabel]="fieldOptionsLabel | translate : fieldNameForOptionsMenu"
        [isInAccessibilityMode]="isInAccessibilityMode"
        [displayFieldOptions]="displayFieldOptions"
        [fieldAutomationId]="fieldAutomationId"
        soho-tooltip
        [popover]="true"
        [title]="popoverTitle"
        [placement]="'right'"
        [trigger]="'click'"
        (focusin)="onFieldFocus($event)"
        (focusout)="onFieldBlur($event)"
        (contextmenu)="onContextMenu($event)">
        <ng-container *ngIf="!displayAsText; else displayField">
            <div class="bcf-editor">
                <div class="editor-container lm-lpl-editor" #editorContainer soho-alert soho-trackdirty [attr.id]="id" [attr.bindId]="bindId"></div>
            </div>
        </ng-container>
        <ng-template #displayField>
            <p
                [attr.id]="id"
                [ngClass]="fieldClassesString"
                [attr.tabindex]="isInAccessibilityMode ? 0 : -1"
                soho-alert
                lm-field-style
                [specField]="specField"
                [fieldStyle]="layoutObject?.fieldStyle"
                [recalculateStyles]="triggerValueChange | async"
            >{{modelField.valueChanged | async | formatMessageRule:true:field.text:model:specFields}}</p>
        </ng-template>
    </div>
</div>
<ng-container *ngIf="!displayAsText">
    <ng-container *ngIf="isBusClassTotal; else others">
        <div class="two-button">
            <button
                    soho-button="primary"
                    [disabled]="disableDimensions$ | async"
                    (click)="onBuildCubeRelation()"
                    attr.data-automation-id="{{builderButtonAutomationId}}"
            >{{ 'SetDimensions' | translate}}
            </button>
            <ng-template [ngIf]="!hideTestMeasures">
                <button
                        soho-button="secondary"
                        (click)="onPreviewCubeRelation()"
                        attr.data-automation-id="{{previewButtonAutomationId}}"
                >{{ 'Validate' | translate }}
                </button>
            </ng-template>
        </div>
    </ng-container>
    <ng-template #others>
        <ng-container *ngIf="!isBusClassCompute; else compute">
            <div class="two-button">
                <button
                        soho-button="primary"
                        [disabled]="readOnly$ | async"
                        (click)="onBuildButtonEvent()"
                        attr.data-automation-id="{{builderButtonAutomationId}}"
                >{{ 'BuilderNoEllipses' | translate}}</button>
                <button *ngIf="layoutObject.lplFieldInfo?.mode !== 'DerivedField'"
                        soho-button="secondary"
                        [disabled]="readOnly$ | async"
                        (click)="onPreviewButtonEvent()"
                        attr.data-automation-id="{{previewButtonAutomationId}}"
                >{{ 'PreviewNoEllipses' | translate }}</button>
            </div>
        </ng-container>
        <ng-template #compute>
            <div class="one-button">
                <button
                        soho-button="primary"
                        [disabled]="readOnly$ | async"
                        (click)="onComputeBuildButtonEvent()"
                        attr.data-automation-id="{{builderButtonAutomationId}}"
                >{{ 'BuilderNoEllipses' | translate}}</button>
            </div>
        </ng-template>
    </ng-template>
</ng-container>
